
const { appUtils } = require('./app-utils.js');

async function updateCart(order_id, product_id, action='add', quantity=1) {
  console.log(`Going to ${action} ${quantity} piece for product ${product_id}`)
  const payload = {
    product_id,
    action,
    quantity
  }
  // query
  const query = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  let url = `/orders/${order_id}/update_cart.js`
  if (query._t)
    url += `?_t=${query._t}`

  try {
    window.jQuery('#cart_errors').html('')
    window.jQuery('#cart_errors_mobile').html('')

    const res = await appUtils.axiosSend(url, {
      order: payload
    }, 'put')
    console.log(res.data)
    window.jQuery('#cart').html(res.data)
    window.jQuery('#mobile_cart').html(res.data)
  } catch (ex) {
    if (ex.response?.data?.error) {
      console.log(ex.response.data.error)

      const errString = ex.response.data.error.messages[Object.keys(ex.response.data.error.messages)[0]].map((message => `<li class='fs-6'>${message}</li>`)).join('\n')

      window.jQuery('#cart_errors').html("<ul class='list-unstyled'>" + errString + '</ul>');
      window.jQuery('#cart_errors_mobile').html("<ul class='list-unstyled'>" + errString + '</ul>');
    } else {
      window.jQuery('#cart_errors').html("<ul class='list-unstyled'><li class='fs-6'>Errore imprevisto, si prega di ricaricare la pagina e riprovare</li></ul>");
      window.jQuery('#cart_errors_mobile').html("<ul class='list-unstyled'><li class='fs-6'>Errore imprevisto, si prega di ricaricare la pagina e riprovare</li></ul>");
    }
  }
}

window.jQuery(document).ready(function(){
  window.jQuery('.add_to_cart').on('click', function(ev) {
    ev.preventDefault()
    const orderId = window.jQuery('#products').data('orderId')
    const prodId = window.jQuery(this).data('productId')
    updateCart(orderId, prodId, 'add', 1)
  });

  window.jQuery('body').on('click', '.order-recap__qty-add', function(ev) {
    ev.preventDefault()
    const parent = window.jQuery(this).parent()
    const orderId = window.jQuery('#products').data('orderId')
    const prodId = window.jQuery(parent).data('productId')
    updateCart(orderId, prodId, 'add', 1)
  });

  window.jQuery('body').on('click', '.order-recap__qty-remove', function(ev) {
    ev.preventDefault()
    const parent = window.jQuery(this).parent()
    const orderId = window.jQuery('#products').data('orderId')
    const prodId = window.jQuery(parent).data('productId')
    updateCart(orderId, prodId, 'remove', 1)
  });

  window.jQuery('body').on('click', '.order-recap__delete', function(ev) {
    ev.preventDefault()
    const parent = jQuery(this).parent()
    const orderId = jQuery('#products').data('orderId')
    const prodId = jQuery(parent).find('.order-recap__qty').data('productId')
    updateCart(orderId, prodId, 'remove', -1)
  });

})